import { takeLatest, put } from "redux-saga/effects"
import types from "constants/action-types"
import { fetChAllPatterns, setSaved } from "./actions"
import visitor from "services/visitor"
import patternsService from "services/patterns"

function* fetchUserCreditionals() {
  const visitorId = yield localStorage?.getItem("visitorId")
  try {
    const {
      // password,
      // googleId,
      // email,
      // role,
      // createdAt,
      // updatedAt,
      ...visitorDatas
    } = yield visitor.getOne(visitorId)
    yield put(setSaved(visitorDatas))
    const patterns = yield patternsService.getAll()
    yield put(fetChAllPatterns(patterns))
  } catch (error) {
    console.log("error", error)
  }
}

export default function* userDatasSaga() {
  yield takeLatest(types.GET_USERDATAS, fetchUserCreditionals)
}
